import Query from '../../../components/Report';

const query = new Query('search-collected-pages');

export default query;
